export default __webpack_public_path__ + "static/media/diamond-clarity_over-md@3x.dc73eb8b.png";